import PropTypes from 'prop-types';

import SahIcon from '../../icons/SahIcon';
import HomeCheckerImage from '../../VerificationInfo/HomeCheckerImage';
import VerificationIconWrapper from '../../VerificationIconWrapper';

import './CheckedIconPhoto.scss';
import ListingCheckedLabelCircledIcon from '../../icons/ListingCheckedLabelCircledIcon';

const CheckedIconPhoto = ({ isVerified = false, photoUrl = null }) => {
  if (isVerified && photoUrl) {
    return (
      <VerificationIconWrapper className="checked-icon__homechecker-image">
        <HomeCheckerImage photoUrl={photoUrl} defaultNode={<SahIcon />} />
      </VerificationIconWrapper>
    );
  }
  if (isVerified && !photoUrl) {
    return (
      <VerificationIconWrapper>
        <SahIcon />
      </VerificationIconWrapper>
    );
  }

  return <ListingCheckedLabelCircledIcon />;
};

export default CheckedIconPhoto;

CheckedIconPhoto.propTypes = {
  photoUrl: PropTypes.string,
  isVerified: PropTypes.bool
};
